import { initSgBootstrap } from '@/utils/theme.ts';

import 'ag-grid-community/styles/ag-grid.css';
import './index.css';

initSgBootstrap();
